
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const CompanyPage = lazy(() => import('../pages/company/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

import CompanyInfoPage from '../pages/company-info/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/company',
    element: <CompanyPage />
  },
  {
    path: '/company-info',
    element: <CompanyInfoPage />
  },
  {
    path: '/careers',
    element: <CareersPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
